module.exports = "/build/images/minusButton.svg?738a7d8cb39d866de2e68b705181e29f";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/minusButton.svg
// module id = 531
// module chunks = 0